import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import userImg from "../../../../img/DynamicSoftware.png";
import {
  IoCallOutline,
  IoBusinessOutline,
} from "react-icons/io5";
import PayRollTable from "../../../../components/Tables/PayRollTable";

import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext"; 

export default function Profile({ employeeName }) {

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { EmployeeProfileDtldata, EmployeeProfile1data } = useSelector(
    (state) => state.PayRollSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  const [hoverIndex, setHoverIndex] = useState(null);

  const getRows =
    EmployeeProfileDtldata?.Data?.length > 0
      ? EmployeeProfileDtldata.Data.map((item, index) => ({
          id: index + 1,
          Month: item?.Month || "",
          Apr: item?.Apr || 0,
          May: item?.May || 0,
          Jun: item?.Jun || 0,
          Jul: item?.Jul || 0,
          Aug: item?.Aug || 0,
          Sep: item?.Sep || 0,
          Oct: item?.Oct || 0,
          Nov: item?.Nov || 0,
          Dec: item?.Dec || 0,
          Jan: item?.Jan || 0,
          Feb: item?.Feb || 0,
          Mar: item?.Mar || 0,
          Total: item?.Total || 0,
        }))
      : [];

  const getColumns = [
    // { accessor: "id", label: "ID" },
    {
      key: "Month",
      label: "Month",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "Apr", label: "Apr", align: "right", format: "true" },
    { key: "May", label: "May", align: "right", format: "true" },
    { key: "Jun", label: "Jun", align: "right", format: "true" },
    { key: "Jul", label: "Jul", align: "right", format: "true" },
    { key: "Aug", label: "Aug", align: "right", format: "true" },
    { key: "Sep", label: "Sep", align: "right", format: "true" },
    { key: "Oct", label: "Oct", align: "right", format: "true" },
    { key: "Nov", label: "Nov", align: "right", format: "true" },
    { key: "Dec", label: "Dec", align: "right", format: "true" },
    { key: "Jan", label: "Jan", align: "right", format: "true" },
    { key: "Feb", label: "Feb", align: "right", format: "true" },
    { key: "Mar", label: "Mar", align: "right", format: "true" },
    { key: "Total", label: "Total", align: "right", format: "true" },
  ];
  const dummyData = {
    EmplName: EmployeeProfile1data?.Data?.[0]?.EmplName,
    EmplExperience: EmployeeProfile1data?.Data?.[0]?.EmplExperience,
    Deptname: EmployeeProfile1data?.Data?.[0]?.Deptname,
    Designation: EmployeeProfile1data?.Data?.[0]?.Designation,
    DateOfBirth: EmployeeProfile1data?.Data?.[0]?.DateOfBirth,
    JoiningDate: EmployeeProfile1data?.Data?.[0]?.JoiningDate,
    BloodGroup: EmployeeProfile1data?.Data?.[0]?.BloodGroup,
    MobileNo: EmployeeProfile1data?.Data?.[0]?.MobileNo,
    BankName: EmployeeProfile1data?.Data?.[0]?.BankName,
    PfNo: EmployeeProfile1data?.Data?.[0]?.PfNo,
    UanNo: EmployeeProfile1data?.Data?.[0]?.UanNo,
    ESINo: EmployeeProfile1data?.Data?.[0]?.ESINo,
    AdharNo: EmployeeProfile1data?.Data?.[0]?.AdharNo,
    EmergencyNo: EmployeeProfile1data?.Data?.[0]?.EmergencyNo,
    BankAc: EmployeeProfile1data?.Data?.[0]?.BankAc,
    Photo64: EmployeeProfile1data?.Data?.[0]?.Photo,
  };

  const getValue = (val) => val || "-";
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB");
  };
  const boxData = [
    {
      label: "Employee Name",
      value: getValue(dummyData?.EmplName),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Designation",
      value: getValue(dummyData?.Designation),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Date Of Birth",
      value: formatDate(dummyData?.DateOfBirth),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Joining Date",
      value: formatDate(dummyData?.JoiningDate),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Blood Group",
      value: getValue(dummyData?.BloodGroup),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Mobile",
      value: getValue(dummyData?.MobileNo),
      icon: <IoCallOutline />,
    },
    {
      label: "Emergency",
      value: getValue(dummyData?.EmergencyNo),
      icon: <IoCallOutline />,
    },
    {
      label: "Bank",
      value: getValue(dummyData?.BankName),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Account No",
      value: getValue(dummyData?.BankAc),
      icon: <IoBusinessOutline />,
    },
    {
      label: "UAN",
      value: getValue(dummyData?.UanNo),
      icon: <IoBusinessOutline />,
    },
    {
      label: "PF",
      value: getValue(dummyData?.PfNo),
      icon: <IoBusinessOutline />,
    },
    {
      label: "ESI",
      value: getValue(dummyData?.ESINo),
      icon: <IoBusinessOutline />,
    },
    {
      label: "Aadhar",
      value: getValue(dummyData?.AdharNo),
      icon: <IoBusinessOutline />,
    },
  ];
  // ✅ Employee select check
  if (!employeeName || employeeName.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
          fontSize: "18px",
          color:
            isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour10,
        }}
      >
        Please Select Employee Name
      </div>
    );
  }

  if (EmployeeProfileDtldata === "no" || EmployeeProfileDtldata === null) {
    return (
      <div
        style={{
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }
  return (
    <div>
      <div
        style={{
          marginTop: "15px",
          borderRadius: "12px",
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Row>
          <Col>
            <div
              style={{
                border: `1px solid ${
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10
                }`,
                borderRadius: "10px",
                overflow: "hidden",
                background:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour2,
              }}
            >
              <div
                style={{
                  padding: "20px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour3
                      : iscolourDark?.Colour3,
                  borderBottom: `1px solid ${
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour10
                  }`,
                }}
              >
                <Row className="align-items-center">
                  <Col xs={12}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* IMAGE */}
                      <img
                        src={userImg}
                        alt="Customer"
                        style={{
                          width: "95px",
                          height: "95px",
                          borderRadius: "20px",
                          border: `2px solid ${
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour10
                          }`,
                        }}
                      />

                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "10px",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "6px",
                            }}
                          >
                            {/* Department Name */}
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color:
                                  isdark === "light"
                                    ? iscolour?.Colour10
                                    : iscolourDark?.Colour10,
                              }}
                            >
                              {dummyData.Deptname}
                            </div>

                            {/* Experience */}
                            <div
                              style={{
                                fontSize: "13px",
                                color:
                                  isdark === "light"
                                    ? iscolour?.Colour10
                                    : iscolourDark?.Colour10,
                              }}
                            >
                              Experience: {dummyData.EmplExperience}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* 🔽 BOTTOM SECTION */}
              <div style={{ padding: "12px" }}>
                <Row className="g-2">
                  {boxData.map((item, i) => (
                    <Col xl={4} lg={4} md={6} sm={6} xs={12} ke={i}>
                      <div
                        onMouseEnter={() => setHoverIndex(i)}
                        onMouseLeave={() => setHoverIndex(null)}
                        style={{
                          border: `1px solid ${
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour10
                          }`,
                          borderRadius: "8px",
                          padding: "10px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          background:
                            hoverIndex === i
                              ? isdark === "light"
                                ? iscolour?.Colour2
                                : iscolourDark?.Colour4
                              : isdark === "light"
                                ? iscolour?.Colour1
                                : iscolourDark?.Colour2,
                        }}
                      >
                        <div
                          style={{
                            fontSize: "18px",
                            minWidth: "24px",
                            display: "flex",
                            justifyContent: "center",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour10,
                            background:
                              isdark === "light"
                                ? iscolour?.Colour3
                                : iscolourDark?.Colour3,
                            padding: "8px",
                            borderRadius: "6px",
                          }}
                        >
                          {item.icon}
                        </div>

                        <div style={{ flex: 1, overflow: "hidden" }}>
                          <div
                            style={{
                              fontSize: "14px",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour6
                                  : iscolourDark?.Colour10,
                            }}
                          >
                            {item.label}
                          </div>
                          <div
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour10
                                  : iscolourDark?.Colour10,
                            }}
                          >
                            {item.value}
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  padding: "14px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                }}
              >
                EMPLOYEE PROFILE
              </div>

              <PayRollTable
                columns={getColumns}
                data={getRows}
                showSearch={true}
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
